import { MultiSelect } from "@mantine/core";
import { useState } from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { getAssignationManagementResidueFinalDestinationList } from "../../../../helpers/residue/backend_helper";
import { useEffect } from "react";

const AssignationTreatmentResidueCategorySection = ({ key, finalDestination, residueCategory, treatmentDetails, handleUpdateAssignations }) => {
    const [dataAssignation, setDataAssignation] = useState(null);
    const [originalSelectedValues, setOriginalSelectedValues] = useState([]);
    const [selectedValues, setSelectedValues] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const getAssignation = async () => {
        setIsLoading(true);
        let response = null;

        try {
            response = await getAssignationManagementResidueFinalDestinationList({
                final_destination_id: finalDestination._id,
                residue_category_id: (residueCategory ? residueCategory._id : '')
            });

            const assignation = response[0];
            if (assignation) {
                setDataAssignation(assignation);
                setSelectedValues(assignation.treatment_detail_ids.map((item) => item));
            }
            setIsLoading(false);
        } catch (err) {
            switch (err.status) {
                default:
                    console.log(err.message);
            }
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (finalDestination && residueCategory) {
            getAssignation();
        }
    }, [finalDestination, residueCategory])

    useEffect(() => {
        if (!isLoading) {
            // console.log('categoria residuo: ', residueCategory);
            if (dataAssignation) {
                handleUpdateAssignations({
                    ...dataAssignation,
                    treatment_detail_ids: selectedValues
                });
            }
            if (!dataAssignation && finalDestination && residueCategory) {
                handleUpdateAssignations({
                    _id: '',
                    final_destination_id: finalDestination._id,
                    residue_category_id: residueCategory._id,
                    treatment_detail_ids: selectedValues
                });
            }
        }
    }, [
        dataAssignation,
        isLoading,
        finalDestination,
        residueCategory,
        selectedValues
    ])

    return (
        <Row className='g-3 py-2 position-relative'>
            <Col lg={6}>
                <Label for={`residue-category-${key}`} className='form-label'>
                    Categoría de Residuo
                </Label>
                <Input
                    name={`residue-category-${key}`}
                    className='form-control'
                    type='text'
                    // validate={{ required: { value: true } }}
                    // onChange={validation.handleChange}
                    // onBlur={validation.handleBlur}
                    value={(residueCategory ? residueCategory.name : '')}
                    disabled={true}
                // invalid={
                // 	validation.touched.x &&
                // 	validation.errors.x
                // 		? true
                // 		: false
                // }
                />
                {/* {validation.touched.x && validation.errors.x ? (
                    <FormFeedback type='invalid'>
                        {validation.errors.x}
                    </FormFeedback>
                ) : null} */}
            </Col>
            <Col lg={6}>
                <Label for={`treatment-detail-${key}`} className='form-label'>
                    Vincular tratamiento del residuo
                </Label>
                <MultiSelect
                    name={`treatment-detail-${key}`}
                    // searchable
                    clearable={true}
                    value={selectedValues}
                    data={treatmentDetails}
                    onChange={setSelectedValues}
                    // maxSelectedValues={20}
                    placeholder={(isLoading ? 'Cargando...' : 'Seleccione detalles de tratamientos')}
                    disabled={isLoading}
                />
            </Col>

        </Row>
    )
}

export default AssignationTreatmentResidueCategorySection;
